<template>
  <div class="table mb-0">
    <DVIRTemplateEditor v-if="view === 'edit' && editorTemplate" :template="editorTemplate"
      @close="onEditorClosed" />
    <ReviewDVIR v-else-if="view === 'review'" :inspection="routeInspection" @close="onDVIRFormClosed" />
    <AddDVIRForm v-else-if="view === 'dvir'" :unit="dvirUnit" :template="dvirTemplate" :inspection="routeInspection"
      @close="onDVIRFormClosed" @submit="onDVIRSubmitted" />
    <template v-else>
      <div class="expiry-data d-flex justify-content-between align-items-center flex-wrap mb-3">
        <h2 class="text-left mb-0">
          {{ $t("dvir.tabDvirs") }}
        </h2>
        <b-button v-if="activeTab !== 'report'" @click="openAddModal()"
          class="export equipment d-flex justify-content-center align-items-center w-fit-content mr-1"
          variant="primary">
          <b-icon icon="plus" class="p-0" aria-hidden="true"></b-icon>
          <p class="mb-0 ml-2 text-white p-0">
            {{ activeTab === "dvirs" ? $t("dvir.addDvir") : $t("dvir.addTemplate") }}
          </p>
        </b-button>
      </div>
      <div class="data-table team-data-table bg-white rounded table-custom-border">
        <div class="bg-white rounded">
          <v-tabs class="team-tabs p-0 mb-0" :class="activeTab === 'templates' ? 'b-y-0' : ''" show-arrows
            v-model="tabIndex">
            <v-tab>{{ $t("dvir.tabDvirs") }}</v-tab>
            <v-tab class="with-border">{{ $t("dvir.tabReport") }}</v-tab>
            <v-tab>{{ $t("dvir.tabTemplates") }}</v-tab>
          </v-tabs>
        </div>
        <div class="bg-white rounded px-0" :class="activeTab !== 'templates' ? 'pt-3' : ''">
          <div class="p-0">
            <div>
              <div class="filter-box" v-if="isTableMounted">
                <div class="d-flex mb-3 px-3 px-sm-4 flex-wrap gap-3" v-if="activeTab !== 'templates'">
                  <b-form-group class="text-left label font-weight-normal search-field mb-0">
                    <b-input-group class="username-input-field">
                      <b-form-input type="text" :placeholder="$t('maintenanceShared.search')"
                        v-model="filterFields.search" class="unit f-12" @keyup.enter="onSearch()"></b-form-input>
                      <b-input-group-append>
                        <b-button variant="primary" @click="onSearch()">
                          <svg width="14" height="15" viewBox="0 0 14 15" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path
                              d="M6.14286 11.7857C8.98318 11.7857 11.2857 9.48318 11.2857 6.64286C11.2857 3.80254 8.98318 1.5 6.14286 1.5C3.30254 1.5 1 3.80254 1 6.64286C1 9.48318 3.30254 11.7857 6.14286 11.7857Z"
                              stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M10 10.5L13 13.5" stroke="white" stroke-width="2" stroke-linecap="round"
                              stroke-linejoin="round" />
                          </svg>
                        </b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                  <b-form-group :label="''" class="text-left report-datepicker mb-0">
                    <date-picker v-model="filterFields.date" :formatter="momentFormat" @change="getDVIRData()"
                      :range-separator="' - '" :placeholder="$t('maintenanceShared.selectDate')" @clear="filterFields.date = null" range
                      class="date-picker-custom f-12" :shortcuts="shortcuts"></date-picker>
                  </b-form-group>
                  <div class="ml-auto align-items-center d-none d-sm-flex flex-wrap"
                    v-if="activeTab === 'dvirs' || activeTab === 'report'">
                    <div class="position-relative">
                      <div class="position-absolute notification-badge" v-if="activeFiltersCount">
                        {{ activeFiltersCount }}
                      </div>
                      <button class="btn btn-filter-section" @click="$bvModal.show('modal-filter')">
                        <div class="d-flex align-items-center">
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="lucide lucide-sliders-horizontal w-4 h-4" data-id="element-964">
                            <line x1="21" x2="14" y1="4" y2="4"></line>
                            <line x1="10" x2="3" y1="4" y2="4"></line>
                            <line x1="21" x2="12" y1="12" y2="12"></line>
                            <line x1="8" x2="3" y1="12" y2="12"></line>
                            <line x1="21" x2="16" y1="20" y2="20"></line>
                            <line x1="12" x2="3" y1="20" y2="20"></line>
                            <line x1="14" x2="14" y1="2" y2="6"></line>
                            <line x1="8" x2="8" y1="10" y2="14"></line>
                            <line x1="16" x2="16" y1="18" y2="22"></line>
                          </svg>
                          <p class="mb-0 ml-2">{{ $t("documentsPage.filters") }}</p>
                        </div>
                      </button>
                    </div>
                    <b-button v-if="activeTab === 'report'" @click="downloadExcel" variant="dashboard-export-table-btn"
                      class="ml-2">
                      <div class="d-flex align-items-center">
                        <svg width="16" height="16" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M13.0206 6.20996H10.364V7.80592H13.0206C13.8106 7.80592 14.4235 8.21448 14.4235 8.56613V15.6431C14.4235 15.9948 13.8106 16.4033 13.0206 16.4033H2.97916C2.18919 16.4033 1.57628 15.9948 1.57628 15.6431V8.56639C1.57628 8.21475 2.18919 7.80618 2.97916 7.80618H5.63519V6.21023H2.97916C1.30857 6.21023 0 7.24521 0 8.56639V15.6434C0 16.9648 1.30857 17.9996 2.97916 17.9996H13.0208C14.6912 17.9996 16 16.9646 16 15.6434V8.56639C15.9997 7.24494 14.6912 6.20996 13.0206 6.20996Z"
                            fill="#212529" />
                          <path
                            d="M5.66755 3.97792C5.86932 3.97792 6.07082 3.89999 6.22477 3.74411L7.21151 2.74505V6.2104V7.80636V10.8637C7.21151 11.3044 7.56434 11.6617 7.99965 11.6617C8.43497 11.6617 8.78779 11.3044 8.78779 10.8637V7.80636V6.2104V2.69105L9.82787 3.74411C9.98182 3.89999 10.1836 3.97792 10.3851 3.97792C10.5866 3.97792 10.7883 3.89999 10.9423 3.74411C11.2502 3.43264 11.2502 2.92725 10.9423 2.61577L8.58918 0.233276C8.43523 0.0774039 8.23373 0 8.03223 0C8.03013 0 8.02829 0 8.02619 0C8.02409 0 8.02225 0 8.02014 0C7.81864 0 7.61714 0.0774039 7.46319 0.233276L5.11007 2.61577C4.80218 2.92725 4.80218 3.43264 5.11007 3.74411C5.26429 3.89999 5.46579 3.97792 5.66755 3.97792Z"
                            fill="#212529" />
                        </svg>
                        <p class="mb-0 ml-2">{{ $t("dashboardPage.export") }}</p>
                      </div>
                    </b-button>
                  </div>
                </div>
              </div>
              <div v-if="!isTableMounted" class="mt-2" style="height: calc(100vh - 225px); overflow: hidden">
                <b-skeleton-table :rows="17" :columns="currentFields.length"
                  :table-props="{ hover: true, responsive: true }"></b-skeleton-table>
              </div>
              <b-table v-else :sticky-header="activeTab === 'templates' ? 'calc(100vh - 250px)' : 'calc(100vh - 320px)'"
                responsive :fields="currentFields" :items="currentItems" hover :per-page="perPage"
                :current-page="currentPage" :tbody-tr-class="rowClass" show-empty>
                <template #cell(unit_no)="data">
                  <p class="mb-0" :class="canOpenDVIR(data.item) ? 'text_primary cursor-pointer' : ''"
                    @click="canOpenDVIR(data.item) ? openDVIRDetails(data.item) : null">
                    {{ data.value }}
                  </p>
                </template>
                <template #cell(driver)="data">
                <div v-if="data.value && data.value !== '-'" class="d-flex align-items-center justify-content-between">
                  {{ data.value }}
                  <svg @click="sendNotification(data.item)" class="cursor-pointer" width="16" height="20" viewBox="0 0 23 25" fill="none" xmlns="http://www.w3.org/2000/svg"><path opacity="1.0" d="M22.1609 15.7696L19.8273 13.436V10.3447C19.8246 8.20836 19.0299 6.14891 17.5968 4.56457C16.1638 2.98023 14.1941 1.98353 12.0688 1.76721V0H10.3447V1.76721C8.21934 1.98353 6.2497 2.98023 4.81663 4.56457C3.38355 6.14891 2.58884 8.20836 2.58617 10.3447V13.436L0.252582 15.7696C0.0909043 15.9312 4.88246e-05 16.1505 0 16.3791V18.9652C0 19.1939 0.0908235 19.4131 0.25249 19.5748C0.414157 19.7365 0.633425 19.8273 0.862056 19.8273H6.89645V20.4971C6.8777 21.5907 7.26317 22.6528 7.979 23.4799C8.69484 24.3069 9.69068 24.8407 10.7757 24.9789C11.375 25.0384 11.9801 24.9717 12.552 24.7832C13.124 24.5948 13.6502 24.2887 14.0968 23.8847C14.5434 23.4806 14.9004 22.9876 15.145 22.4373C15.3896 21.887 15.5163 21.2916 15.517 20.6893V19.8273H21.5514C21.78 19.8273 21.9993 19.7365 22.161 19.5748C22.3226 19.4131 22.4135 19.1939 22.4135 18.9652V16.3791C22.4134 16.1505 22.3226 15.9312 22.1609 15.7696ZM13.7929 20.6893C13.7929 21.3752 13.5204 22.033 13.0354 22.518C12.5504 23.003 11.8926 23.2755 11.2067 23.2755C10.5208 23.2755 9.86303 23.003 9.37803 22.518C8.89303 22.033 8.62056 21.3752 8.62056 20.6893V19.8273H13.7929V20.6893ZM20.6893 18.1032H1.72411V16.736L4.0577 14.4024C4.21938 14.2407 4.31023 14.0215 4.31028 13.7929V10.3447C4.31028 8.51562 5.03687 6.76148 6.3302 5.46815C7.62354 4.17481 9.37768 3.44822 11.2067 3.44822C13.0358 3.44822 14.7899 4.17481 16.0833 5.46815C17.3766 6.76148 18.1032 8.51562 18.1032 10.3447V13.7929C18.1032 14.0215 18.1941 14.2407 18.3558 14.4024L20.6893 16.736V18.1032Z" fill="#2D69F6"></path></svg>
                </div>
                <div v-else>-</div>
                </template>
                <template #cell(is_active)="data">
                  <b-form-checkbox size="lg" class="ml-2" v-model="data.item.is_active" name="check-button" switch
                    @change="updateTemplate(data.item)" />
                </template>
                <template #cell(completion_rate)="data">
                  <span>{{
                    data.value === null || data.value === undefined
                      ? "-"
                      : `${Math.round(data.value)}%`
                  }}</span>
                </template>
                <!-- Compliance days: a filled box was inspected, an empty one wasn't. -->
                <template #cell()="data">
                  <span v-if="data.value === 'yes' || data.value === 'no'" class="day-box"
                    :class="{ 'day-box--done': data.value === 'yes' }"></span>
                  <span v-else>{{ data.value }}</span>
                </template>
                <template #cell(inspected_at)="data">
                  <span>{{ formatDate(data.value) }}</span>
                </template>
                <template #cell(last_inspection)="data">
                  <span>{{ data.value ? formatDate(data.value) : "-" }}</span>
                </template>
                <template #cell(defect_count)="data">
                  <span class="font-weight-bold" :class="data.value ? 'text-red' : 'text-green'">
                    {{ data.value }}
                  </span>
                </template>
                <template #cell(fixed_count)="data">
                  <span v-if="data.item.defect_count" class="font-weight-bold" :class="data.value >= data.item.defect_count ? 'text-green' : 'text-red'
                    ">
                    {{ data.value }}
                  </span>
                  <span v-else>-</span>
                </template>
                <template #cell(safety_status)="data">
                  <span v-if="data.value" class="dvir-status" :class="safetyStatusClass(data.value)">
                    {{ data.value }}
                  </span>
                  <span v-else class="dvir-status-draft dvir-status">
                    {{ $t("dvir.draft") }}
                  </span>
                </template>
                <template #cell(action)="data">

                  <svg @click="editTemplate(data.item)" class="mr-4 cursor-pointer" width="18" height="18"
                    viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M5.52719 16.7477L14.5274 7.74753L10.2525 3.4726L1.25226 12.4728C1.12836 12.5969 1.04034 12.7522 0.997548 12.9222L0 18L5.07684 17.0025C5.2473 16.9598 5.40322 16.8717 5.52719 16.7477V16.7477ZM17.4329 4.84205C17.796 4.47881 18 3.98622 18 3.4726C18 2.95898 17.796 2.46639 17.4329 2.10315L15.8968 0.567123C15.5336 0.203994 15.041 0 14.5274 0C14.0138 0 13.5212 0.203994 13.1579 0.567123L11.6219 2.10315L15.8968 6.37808L17.4329 4.84205Z"
                      fill="#2CCE89" />
                  </svg>
                  <svg @click="duplicateTemplate(data.item)" class="mr-4 cursor-pointer" width="19" height="19"
                    viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M9.84375 10.7813V12.8906C9.84375 13.2788 9.52875 13.5938 9.14062 13.5938H3.04688C2.86039 13.5938 2.68155 13.5197 2.54969 13.3878C2.41783 13.2559 2.34375 13.0771 2.34375 12.8906V4.92188C2.34375 4.53375 2.65875 4.21875 3.04688 4.21875H4.21875C4.53286 4.21854 4.84644 4.24446 5.15625 4.29625M9.84375 10.7813H11.9531C12.3412 10.7813 12.6562 10.4663 12.6562 10.0781V7.03125C12.6562 4.24375 10.6294 1.93063 7.96875 1.48375C7.65894 1.43196 7.34536 1.40604 7.03125 1.40625H5.85938C5.47125 1.40625 5.15625 1.72125 5.15625 2.10938V4.29625M9.84375 10.7813H5.85938C5.67289 10.7813 5.49405 10.7072 5.36219 10.5753C5.23033 10.4434 5.15625 10.2646 5.15625 10.0781V4.29625M12.6562 8.4375V7.26563C12.6562 6.70619 12.434 6.16966 12.0384 5.77407C11.6428 5.37849 11.1063 5.15625 10.5469 5.15625H9.60938C9.42289 5.15625 9.24405 5.08217 9.11219 4.95031C8.98033 4.81845 8.90625 4.63961 8.90625 4.45313V3.51563C8.90625 3.23862 8.85169 2.96432 8.74568 2.7084C8.63968 2.45248 8.4843 2.21995 8.28843 2.02407C8.09255 1.8282 7.86002 1.67282 7.6041 1.56682C7.34818 1.46081 7.07388 1.40625 6.79688 1.40625H6.09375"
                      stroke="#2D69F6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                  <svg @click="showTemplateDeletePopup(data.item.id)" class="cursor-pointer" width="19" height="20"
                    viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 5.15704H17.6139" stroke="#FF0000" stroke-width="1.5" stroke-linecap="round"
                      stroke-linejoin="round" />
                    <path
                      d="M3.0766 5.15704H15.537V17.6175C15.537 17.9846 15.3911 18.3368 15.1315 18.5964C14.8719 18.856 14.5197 19.0019 14.1525 19.0019H4.46109C4.0939 19.0019 3.74175 18.856 3.4821 18.5964C3.22247 18.3368 3.0766 17.9846 3.0766 17.6175V5.15704Z"
                      stroke="#FF0000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    <path
                      d="M5.84607 5.15347V4.46123C5.84607 3.54325 6.21073 2.66287 6.85984 2.01377C7.50894 1.36466 8.38932 1 9.3073 1C10.2253 1 11.1057 1.36466 11.7548 2.01377C12.4039 2.66287 12.7685 3.54325 12.7685 4.46123V5.15347"
                      stroke="#FF0000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M7.23175 9.3065V14.8466" stroke="#FF0000" stroke-width="1.5" stroke-linecap="round"
                      stroke-linejoin="round" />
                    <path d="M11.385 9.3065V14.8466" stroke="#FF0000" stroke-width="1.5" stroke-linecap="round"
                      stroke-linejoin="round" />
                  </svg>
                </template>
              </b-table>
              <div class="entries-pagination px-0 px-sm-2" v-if="isTableMounted">
                <div class="d-flex align-items-center flex-wrap">
                  <div class="text-left show-entries mr-md-3 pl-3 pl-md-0 ml-md-0">
                    <b-form-select v-model="perPage" :options="pageOptions" />
                  </div>
                  <p class="my-0 pr-3 pr-md-0 mr-md-1 mt-0 f-14">{{ positionText }}</p>
                  <div class="pagination">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"
                      aria-controls="my-table"></b-pagination>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <b-modal id="modal-add-dvir" centered no-close-on-backdrop no-close-on-esc
      :footer-class="'d-block border-0 pt-0 pb-3 m-0'" :body-class="'px-3 pt-2 overflow-preview-auto'"
      :header-class="'align-items-center'" scrollable>
      <template #modal-header="{ close }">
        <h5 class="modal-title">
          {{ $t("dvir.addTemplate") }}
        </h5>
        <b-button size="sm" class="d-none" variant="outline-danger" @click="close()">
          Close Modal
        </b-button>
      </template>
      <p class="f-12 text-left mb-3 mt-2">
        {{ $t("dvir.startingPointHint") }}
      </p>
      <div class="starter-grid">
        <div v-for="base in templateBases" :key="base.key" class="starter-card" @click="createFromBase(base)">
          <b-img v-if="base.style.img" :src="base.style.img" class="starter-icon-img"></b-img>
          <div v-else class="starter-icon" :style="{ background: base.style.bgColor }">
            <b-icon :icon="base.style.icon" :style="{ color: base.style.color }"></b-icon>
          </div>
          <div class="f-14 font-weight-bold text-black">{{ base.name }}</div>
          <div class="f-12 text-grey starter-sub">{{ base.description }}</div>
        </div>
      </div>
      <template #modal-footer>
        <div class="text-right modal-footer border-0 p-0 mb-0 mt-0">
          <b-button class="mx-0 h-40px w-100px m-0" variant="secondary" @click="$bvModal.hide('modal-add-dvir')">
            {{ $t("dvir.cancel") }}
          </b-button>
        </div>
      </template>
    </b-modal>
    <AddDVIR @next="onDVIRTemplateSelected" />
    <DeleteModal v-if="showDeletePopup" @confirm="deleteTemplate($event)" />
    <b-modal id="modal-filter" centered no-close-on-backdrop :footer-class="'d-block p-3 m-0'"
      :body-class="'px-3 pt-3 pb-1'" no-close-on-esc>
      <template #modal-header="{ close }">
        <h5 class="modal-title">
          {{ $t("documentsPage.filtersModalTitle") }}
        </h5>
        <b-button size="sm" class="d-none" variant="outline-danger" @click="close()">
          {{ $t("documentsPage.closeModal") }}
        </b-button>
      </template>
      <div class="body" v-if="activeTab === 'dvirs'">
        <b-form-group :label="$t('dvir.unitType')" class="text-left select_arrow label w-equipment-box mb-3">
          <b-form-select v-model="filterFields.equipment_type" class="f-12 bg-white" @change="getDVIRData()"
            :options="equipmentTypeOptions" />
        </b-form-group>
        <!-- <b-form-group
          v-if="activeTab === 'dvirs'"
          :label="$t('dvir.template')"
          class="text-left select_arrow label w-equipment-box mb-3"
        >
          <b-form-select
            v-model="filterFields.inspection_type"
            class="f-12 bg-white"
            @change="getDVIRData()"
            :options="inspectionTypeOptions"
          />
        </b-form-group> -->
        <b-form-group v-if="activeTab === 'dvirs'" :label="$t('dvir.hasDefects')"
          class="text-left select_arrow label w-equipment-box mb-3">
          <b-form-select v-model="filterFields.has_defects" class="f-12 bg-white" @change="getDVIRData()"
            :options="hasDefectsOptions" />
        </b-form-group>
        <b-form-group v-if="activeTab === 'dvirs'" :label="$t('dvir.defects')"
          class="text-left select_arrow label w-equipment-box mb-3">
          <b-form-select v-model="filterFields.defect_status" class="f-12 bg-white" @change="getDVIRData()"
            :options="defectStatusOptions" />
        </b-form-group>
        <b-form-group v-if="activeTab === 'dvirs'" :label="$t('dvir.status')"
          class="text-left select_arrow label w-equipment-box mb-3">
          <b-form-select v-model="filterFields.safety_status" class="f-12 bg-white" @change="getDVIRData()"
            :options="safetyStatusOptions" />
        </b-form-group>
      </div>
      <div class="body" v-else>
        <b-form-group :label="$t('dvir.unitType')" class="text-left select_arrow label w-equipment-box mb-3">
          <b-form-select v-model="filterFields.equipment_type" class="f-12 bg-white" @change="getDVIRData()"
            :options="equipmentTypeOptions" />
        </b-form-group>
        <b-form-group :label="$t('documentsPage.filterTags')" class="text-left w-equipment-box mb-3">
          <v-select multiple class="f-12 bg-white" :options="allTags" :reduce="(option) => option.id"
            v-model="filterFields.tag_ids" @input="getDVIRData()" />
        </b-form-group>
        <!-- <b-form-group :label="$t('documentsPage.filterUnits')" class="text-left w-equipment-box mb-3">
          <v-select multiple class="f-12 bg-white" :options="unitOptions" :reduce="(option) => option.id"
            v-model="filterFields.unit_ids" @input="getDVIRData()" @search="searchAssets" />
        </b-form-group> -->
      </div>
      <template #modal-footer="">
        <div class="text-right modal-footer border-0 p-0 mb-0 mt-0 justify-content-between mx-0">
          <b-button class="mx-0 mb-0 h-40px w-100px m-0 btn-outline-primary" variant="primary" @click="
            resetFilterFields();
          $bvModal.hide('modal-filter');
          ">{{ $t("documentsPage.reset") }}</b-button>
          <b-button class="mx-0 h-40px w-100px m-0 m-0" block @click="$bvModal.hide('modal-filter')">{{
            $t("documentsPage.close") }}</b-button>
        </div>
      </template>
    </b-modal>
     <SendMessagetoDrivers :ids="[selectDriver]"
      @close="selectDriver = null; notificationMessage = null" :defaultMessage="notificationMessage"
     />
  </div>
</template>
<script>
import * as moment from "moment-timezone";
import { mapActions, mapGetters } from "vuex";
import DeleteModal from "@/components/DeleteModal.vue";
import DVIRTemplateEditor from "@/components/Maintenance/DVIRTemplateEditor.vue";
import AddDVIR from "@/components/Maintenance/AddDVIR.vue";
import AddDVIRForm from "@/components/Maintenance/AddDVIRForm.vue";
import ReviewDVIR from "@/components/Maintenance/ReviewDVIR.vue";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import SendMessagetoDrivers from "@/components/TeamMember/SendMessagetoDrivers.vue";

// Filters outlive the visit, one saved set per tab — the report and the DVIR
// list ask different questions of the same fields.
const DVIR_FILTERS_KEY = "dvirFilters";
export default {
  name: "DVIR",
  components: {
    DeleteModal,
    DVIRTemplateEditor,
    AddDVIR,
    AddDVIRForm,
    ReviewDVIR,
    DatePicker,
    vSelect,
    SendMessagetoDrivers
  },
  data() {
    return {
      tabKeys: ["dvirs", "report", "templates"],
      // Only set while creating from a starter: that template has no id yet, so
      // it cannot be addressed by url on its own.
      starterBase: null,
      selectDriver: null,
      notificationMessage: null,
      showDeletePopup: false,
      templateID: null,
      perPage: 25,
      currentPage: 1,
      isTableMounted: false,
      allTags: [],
      unitOptions: [],
      filterFields: this.savedFilters(),
      pageOptions: [
        { value: 10, text: "10" },
        { value: 25, text: "25" },
        { value: 50, text: "50" },
        { value: 100, text: "100" },
      ],
      momentFormat: {
        //[optional] Date to String
        stringify: (date) => {
          return date ? moment(date).format("ll") : "";
        },
        //[optional]  String to Date
        parse: (value) => {
          if (!value) return null;
          const formats = [
            "ll",
            "LL",
            "MMM D, YYYY",
            "MMMM D, YYYY",
            "M/D/YYYY",
            "MM/DD/YYYY",
            "M-D-YYYY",
            "MM-DD-YYYY",
            "YYYY-MM-DD",
            "YYYY/MM/DD",
            "D MMM YYYY",
            "D MMMM YYYY",
            "D/M/YYYY",
            "DD/MM/YYYY",
          ];
          const m = moment(value, formats, true);
          if (m.isValid()) return m.toDate();
          const lenient = moment(value);
          return lenient.isValid() ? lenient.toDate() : null;
        },
      },
      shortcuts: [
        {
          text: "Today",
          onClick: () => {
            const today = new Date();
            this.filterFields.date = [today, today];
            this.getDVIRData();
          },
        },
        {
          text: "This Week",
          onClick: () => {
            this.filterFields.date = this.thisWeekRange();
            this.getDVIRData();
          },
        },
        {
          text: "This Month",
          onClick: () => {
            const today = new Date();
            const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
            this.filterFields.date = [startOfMonth, today];
            this.getDVIRData();
          },
        },
        {
          text: "This Year",
          onClick: () => {
            const today = new Date();
            const startOfYear = new Date(today.getFullYear(), 0, 1);
            this.filterFields.date = [startOfYear, today];
            this.getDVIRData();
          },
        },
        {
          text: "Last Week",
          onClick: () => {
            const today = new Date();
            const dayOfWeek = today.getDay() || 7;
            const startOfLastWeek = new Date(today);
            startOfLastWeek.setDate(today.getDate() - dayOfWeek - 6);
            const endOfLastWeek = new Date(today);
            endOfLastWeek.setDate(today.getDate() - dayOfWeek);
            this.filterFields.date = [startOfLastWeek, endOfLastWeek];
            this.getDVIRData();
          },
        },
        {
          text: "Last Month",
          onClick: () => {
            const today = new Date();
            const startOfLastMonth = new Date(
              today.getFullYear(),
              today.getMonth() - 1,
              1
            );
            const endOfLastMonth = new Date(today.getFullYear(), today.getMonth(), 0);
            this.filterFields.date = [startOfLastMonth, endOfLastMonth];
            this.getDVIRData();
          },
        },
        {
          text: "Last Year",
          onClick: () => {
            const today = new Date();
            const startOfLastYear = new Date(today.getFullYear() - 1, 0, 1);
            const endOfLastYear = new Date(today.getFullYear() - 1, 11, 31);
            this.filterFields.date = [startOfLastYear, endOfLastYear];
            this.getDVIRData();
          },
        },
      ],
      items: [],
      dvirItems: [],
      reportItems: [],
      reportDates: [],
      dvirTemplate: null,
      dvirUnit: null,
      templateBases: [],
      starterStyles: {
        vehicle: { img: require("@/assets/total_vehicles.svg") },
        trailer: { img: require("@/assets/total_trailers.svg") },
        all: { icon: "list-check", color: "#FFFFFF", bgColor: "#2D69F6" },
        blank: { icon: "plus", color: "#FFFFFF", bgColor: "#2D69F6" },
      },
      defaultStarterStyle: {
        icon: "file-earmark-text",
        color: "#FFFFFF",
        bgColor: "#2D69F6",
      },
    };
  },
  computed: {
    ...mapGetters(["tags", "userCompany", "company"]),
    // Which screen shows is a function of the route, so each one has its own url.
    view() {
      if (this.$route.params.templateId) return "edit";
      if (this.$route.params.inspectionId) {
        return this.$route.name === "DVIRReview" ? "review" : "dvir";
      }
      return "list";
    },
    // The tab lives in the query string so a link reopens on the same one.
    activeTab() {
      const tab = this.$route.query.tab;
      return this.tabKeys.includes(tab) ? tab : "dvirs";
    },
    // A saved template only needs its id — the editor fetches the rest. A starter
    // has none, so it comes from the picker, or from ?starter= after a reload.
    editorTemplate() {
      const templateId = this.$route.params.templateId;
      if (!templateId) return null;
      if (templateId !== "new") return { id: Number(templateId) };
      if (this.starterBase) return this.starterBase;
      const key = this.$route.query.starter;
      return this.templateBases.find((base) => base.key === key) || null;
    },
    // The fill form and the review screen both load themselves from the id.
    routeInspection() {
      const inspectionId = this.$route.params.inspectionId;
      return inspectionId ? { id: Number(inspectionId) } : null;
    },
    tabIndex: {
      get() {
        return Math.max(this.tabKeys.indexOf(this.activeTab), 0);
      },
      set(index) {
        const tab = this.tabKeys[index] || this.tabKeys[0];
        if (tab === this.activeTab) return;
        this.$router.push({ name: "DVIR", query: { tab } });
      },
    },
    typeOptions() {
      const options = [{ value: "", text: "" }];
      if (this.allowViewDocEquipment) {
        options.push({ value: "Vehicle", text: this.$t('documentsPage.typeVehicle') });
        options.push({ value: "Trailer", text: this.$t('documentsPage.typeTrailer') });
      }
      return options;
    },
    // Counts only the filters the active tab actually sends — the report ignores
    // the status and inspection-type ones, so they must not show in its badge.
    activeFiltersCount() {
      const keys =
        this.activeTab === "dvirs"
          ? [
              "date",
              "equipment_type",
              "inspection_type",
              "has_defects",
              "defect_status",
              "safety_status",
              "tag_ids",
              "unit_ids",
            ]
          : ["date", "equipment_type", "tag_ids", "unit_ids"];
      return keys.reduce((count, key) => {
        const value = this.filterFields[key];
        if (Array.isArray(value)) return count + (value.length ? 1 : 0);
        return count + (value !== "" && value !== null ? 1 : 0);
      }, 0);
    },
    equipmentTypeOptions() {
      return [
        { value: null, text: this.$t("dvir.selectOption") },
        { value: "Vehicle", text: this.$t("documentsPage.typeVehicle") },
        { value: "Trailer", text: this.$t("documentsPage.typeTrailer") },
      ];
    },
    // The values the API stores for an inspection type.
    inspectionTypeOptions() {
      return [
        { value: null, text: this.$t("dvir.selectOption") },
        { value: "Pre-Trip", text: this.$t("dvir.preTrip") },
        { value: "Post-Trip", text: this.$t("dvir.postTrip") },
      ];
    },
    hasDefectsOptions() {
      return [
        { value: null, text: this.$t("dvir.selectOption") },
        { value: true, text: this.$t("documentsPage.yes") },
        { value: false, text: this.$t("documentsPage.no") },
      ];
    },
    // The values the API stores for a defect status.
    defectStatusOptions() {
      return [
        { value: null, text: this.$t("dvir.selectOption") },
        { value: "No Defect", text: this.$t("dvir.noDefect") },
        { value: "Corrected", text: this.$t("dvir.defectsCorrected") },
        { value: "Not Corrected", text: this.$t("dvir.defectsNotCorrected") },
      ];
    },
    // A report with no safety status yet is still a draft.
    safetyStatusOptions() {
      return [
        { value: null, text: this.$t("dvir.selectOption") },
        { value: "Active", text: this.$t("dvir.statusActive") },
        { value: "Safe", text: this.$t("dvir.statusSafe") },
        { value: "Unsafe", text: this.$t("dvir.statusUnsafe") },
        { value: "Resolved", text: this.$t("dvir.statusResolved") },
        { value: "Draft", text: this.$t("dvir.draft") },
      ];
    },
    dvirFields() {
      return [
        {
          key: "unit_no",
          label: this.$t("maintenanceShared.unitNo"),
          sortable: true,
          stickyColumn: true,
          thClass: "font-table-weight-bold",
        },
        {
          key: "equipment_type",
          label: this.$t("dvir.unitType"),
          sortable: true,
          thClass: "font-table-weight-bold",
        },
        {
          key: "template_name",
          label: this.$t("dvir.template"),
          sortable: true,
          thClass: "font-table-weight-bold",
        },
        {
          key: "created_by",
          label: this.$t("dvir.createdBy"),
          sortable: true,
          thClass: "font-table-weight-bold",
        },
        {
          key: "inspected_at",
          label: this.$t("dvir.date"),
          sortable: true,
          thClass: "font-table-weight-bold",
        },
        {
          key: "defect_count",
          label: this.$t("dvir.defects"),
          sortable: true,
          thClass: "font-table-weight-bold",
        },
        {
          key: "fixed_count",
          label: this.$t("dvir.fixed"),
          sortable: true,
          thClass: "font-table-weight-bold",
        },
        {
          key: "safety_status",
          label: this.$t("dvir.status"),
          sortable: true,
          thClass: "font-table-weight-bold",
        },
      ];
    },
    templateFields() {
      return [
        {
          key: "name",
          label: this.$t("dvir.name"),
          sortable: true,
          thClass: "font-table-weight-bold",
        },
        // { key: "equipment_type", label: this.$t("maintenanceShared.type"), sortable: true, thClass: "font-table-weight-bold" },
        {
          key: "assigned_summary",
          label: this.$t("dvir.assigned"),
          sortable: true,
          thClass: "font-table-weight-bold",
        },
        {
          key: "is_active",
          label: this.$t("dvir.status"),
          sortable: true,
          thClass: "font-table-weight-bold",
        },
        {
          key: "action",
          label: this.$t("dvir.actionColumn"),
          thClass: "font-table-weight-bold",
        },
      ];
    },
    // Compliance matrix — a row per unit + template, then one column per day in
    // the range.
    today() {
      return moment().format("YYYY-MM-DD");
    },
    reportSpansYears() {
      if (!this.reportDates.length) return false;
      const first = moment(this.reportDates[0]).year();
      const last = moment(this.reportDates[this.reportDates.length - 1]).year();
      return first !== last;
    },
    reportFields() {
      return [
        // These stay put while the days scroll past them.
        {
          key: "unit_no",
          label: this.$t("maintenanceShared.unitNo"),
          thClass: "font-table-weight-bold th-divider sticky-col sticky-col-1",
          tdClass: "sticky-col sticky-col-1",
        },
        {
          key: "type",
          label: this.$t("dvir.type"),
          thClass: "font-table-weight-bold th-divider sticky-col sticky-col-2",
          tdClass: "sticky-col sticky-col-2",
        },
        {
          key: "driver",
          label: this.$t("dvir.driver"),
          thClass: "font-table-weight-bold th-divider sticky-col sticky-col-3",
          tdClass: "sticky-col sticky-col-3",
        },
        {
          key: "template_name",
          label: this.$t("dvir.template"),
          thClass: "font-table-weight-bold sticky-col sticky-col-4",
          tdClass: "sticky-col sticky-col-4",
        },
        ...this.reportDates.map((day) => ({
          key: day,
          // The year is only worth the space when the range crosses one.
          label: moment(day).format(this.reportSpansYears ? "MM/DD/YY" : "MM/DD"),
          thClass: `font-table-weight-bold text-nowrap day-col${day === this.today ? " day-col--today" : ""
            }`,
          tdClass: "day-col",
        })),
        // Pinned to the right edge, opposite the fixed first three.
        {
          key: "completion_rate",
          label: "%",
          thClass: "font-table-weight-bold sticky-col sticky-col-end",
          tdClass: "sticky-col sticky-col-end",
        },
      ];
    },
    currentFields() {
      if (this.activeTab === "templates") return this.templateFields;
      if (this.activeTab === "report") return this.reportFields;
      return this.dvirFields;
    },
    currentItems() {
      if (this.activeTab === "templates") return this.items;
      if (this.activeTab === "report") return this.reportItems;
      return this.dvirItems;
    },
    rows() {
      return this.currentItems.length;
    },
    positionText() {
      const endIndex = this.currentPage * this.perPage;
      const startIndex = this.rows > 0 ? (this.currentPage - 1) * this.perPage + 1 : 0;
      const end = endIndex > this.rows ? this.rows : endIndex;
      return this.$t("maintenanceShared.positionText", {
        start: startIndex,
        end,
        total: this.rows,
      });
    },
  },
  watch: {
    filterFields: {
      handler() {
        this.currentPage = 1;
        this.rememberFilters();
      },
      deep: true,
    },
    // Each tab keeps its own filters, so switching loads that tab's set.
    activeTab: {
      handler(tab) {
        this.filterFields = this.savedFilters(tab);
      },
    },
  },
  methods: {
    ...mapActions([
      "getAllDVIRTemplates",
      "getDVIRTemplateStarters",
      "getAllDVIRData",
      "getDVIRCompliance",
      "deleteDVIRTemplate",
      "setNotification",
      "setLoader",
      "getAllTags",
      "getFilteredEquipments",
      "updateDVIRTemplate",
      "duplicateDVIRTemplate",
      "updateDVIRInspection"
    ]),
    sendNotification(driverData) {
      this.selectDriver = driverData.driver_id;
      this.notificationMessage = this.$t("dvir.notificationMessage", {
        name: driverData.driver || "",
        company: (this.company[0] && this.company[0].name) || "",
      });
      // The modal is only rendered once a driver is picked, so it has to exist
      // before it can be told to open — on the same tick there is nothing there
      // to show, and the click reads as doing nothing.
      this.$nextTick(() => this.$bvModal.show('send-notification-modal'))
    },
    async updateTemplate(data) {
      try {
        const payload = {
          is_active: data.is_active
        }
        await this.updateDVIRTemplate({ id: data.id, payload })
        await this.setNotification({
          msg: this.$t("dvir.templateUpdated"),
          type: "success",
          color: "green",
        })
      }
      catch (e) {
        await this.setNotification({
          msg: typeof e === "string" ? e : this.$t("dvir.templateSaveFailed"),
          type: "error",
          color: "red",
        })
      }
    },
    async searchAssets(searchText) {
      if (!searchText) return;
      try {
        const equipmentRecords = await this.getFilteredEquipments({ unit_no: searchText });
        const options = (equipmentRecords || []).map((item) => ({
          id: `${item.id}`,
          label: item.unit_no,
          type: item.type,
        }));
        // Keep the options behind the current picks so their labels survive a new search.
        const picked = this.filterFields.unit_ids || [];
        const selected = this.unitOptions.filter((option) => picked.includes(option.id));
        this.unitOptions = [...new Map([...selected, ...options].map((item) => [item.id, item])).values()];
      } catch (error) {
        console.error("Error searching units:", error);
      }
    },
    async downloadExcel() {
      try {
        this.setLoader(true);
        const query = this.reportQuery();
        const data = await this.getDVIRCompliance(
          `${query ? `${query}&` : ""}export=csv`
        );
        const blob = new Blob([data], { type: "text/csv" });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.style.display = "none";
        link.href = url;
        link.download = "dvir_report.csv";
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
        await this.setNotification({
          msg: this.$t("maintenanceRecords.fileExported"),
          type: "success",
          color: "green",
        });
      } catch (error) {
        await this.setNotification({
          msg: typeof error === "string" ? error : this.$t("dvir.dvirSaveFailed"),
          type: "error",
          color: "red",
        });
      } finally {
        this.setLoader(false);
      }
    },
    // An already-opened report sits back in grey; unread ones stay white.
    rowClass(item) {
      return item && item.opened ? "row-opened" : "";
    },
    async onSearch() {
      this.currentPage = 1;
      await this.getDVIRData();
    },
    async onDateCleared() {
      // Cleared means cleared: the picker shows nothing, the query carries no
      // range, and that is what gets saved.
      this.filterFields.date = null;
      await this.getDVIRData();
    },
    defaultDateRange() {
      return this.thisWeekRange()
    },
    // The range the page was left on, so coming back shows the same dates
    // rather than resetting to the last seven days.
    filterStorageKey(tab) {
      // `activeTab` is a computed off the route, which data() cannot read yet,
      // so the first call falls back to the query string.
      const current = tab || this.activeTab || this.$route.query.tab;
      return `${DVIR_FILTERS_KEY}:${["dvirs", "report", "templates"].includes(current) ? current : "dvirs"}`;
    },
    emptyFilters() {
      return {
        search: "",
        date: this.defaultDateRange(),
        equipment_type: null,
        inspection_type: null,
        has_defects: null,
        defect_status: null,
        safety_status: "Active",
        tag_ids: [],
        unit_ids: [],
      };
    },
    // Whatever this tab was last filtered by, on top of the empty shape so a
    // field added later still has a value.
    savedFilters(tab) {
      const empty = this.emptyFilters();
      try {
        const saved = JSON.parse(localStorage.getItem(this.filterStorageKey(tab)) || "null");
        if (!saved || typeof saved !== "object") return empty;
        // The picker wants Dates back, not the strings they were stored as. A
        // cleared range was saved as null and stays cleared on return; only a
        // tab that has never been filtered gets the default window.
        const range = Array.isArray(saved.date) && saved.date[0] && saved.date[1]
          ? [new Date(saved.date[0]), new Date(saved.date[1])]
          : null;
        const valid = range && !range.some((entry) => Number.isNaN(entry.getTime()));
        return { ...empty, ...saved, date: valid ? range : null };
      } catch (error) {
        // A half-written value is no reason to break the page.
        console.error("Error reading the saved filters:", error);
        return empty;
      }
    },
    rememberFilters() {
      localStorage.setItem(this.filterStorageKey(), JSON.stringify(this.filterFields));
    },
    
    // The last seven days, ending today — a rolling window rather than a calendar
    // week, so it is always seven columns and never runs into the future.
    thisWeekRange() {
      const today = new Date();
      const weekAgo = new Date(today);
      weekAgo.setDate(today.getDate() - 6);
      return [weekAgo, today];
    },
    async resetFilterFields() {
      this.filterFields.date = this.defaultDateRange();
      this.filterFields.equipment_type = null;
      this.filterFields.inspection_type = null;
      this.filterFields.has_defects = null;
      this.filterFields.defect_status = null;
      this.filterFields.safety_status = 'Active';
      this.filterFields.tag_ids = []
      this.filterFields.unit_ids = []
      this.unitOptions = []
      await this.getDVIRData();
    },
    createFromBase(base) {
      this.$bvModal.hide("modal-add-dvir");
      // Held in memory for this visit; ?starter= is what rebuilds it on a reload.
      this.starterBase = base;
      this.$router.push({
        name: "DVIRTemplateEditor",
        params: { templateId: "new" },
        query: { starter: base.key },
      });
    },
    openEditor(template) {
      this.$router.push({
        name: "DVIRTemplateEditor",
        params: { templateId: `${template.id}` },
      });
    },
    assignedLabel(template) {
      // Empty assigned_units means every unit of the template's equipment_type.
      if ((template.assigned_units || []).length) return this.$t("dvir.specificUnits");
      if (template.equipment_type === "Trailer") return this.$t("dvir.allTrailers");
      if (template.equipment_type === "All") return this.$t("dvir.allUnits");
      return this.$t("dvir.allVehicles");
    },
    // An unfinished DVIR is still being filled in, so only the driver who
    // started it may reopen it. Completed ones are readable by anyone.
    canOpenDVIR(item) {
      if (item.progress_status === "Completed") return true;
      const teamMemberID = this.$store.state.user?.user?.team_member?.id;
      return !!teamMemberID && item.created_by_id === teamMemberID;
    },
    openDVIRDetails(item) {
      if (!this.canOpenDVIR(item)) return;
      this.markOpened(item);
      // A finished DVIR opens read-only for review; anything else resumes filling.
      this.$router.push({
        name: item.progress_status === "Completed" ? "DVIRReview" : "DVIRInspection",
        params: { inspectionId: `${item.id}` },
      });
    },
    async markOpened(item) {
      if (!item || item.opened) return;
      try {
        await this.updateDVIRInspection({ id: item.id, payload: { opened: true } });
        item.opened = true;
      } catch (error) {
        console.error("Error marking DVIR as opened:", error);
      }
    },
    onDVIRTemplateSelected({ unit, template, inspection }) {
      // Carried across for the header; the form still loads itself from the id.
      this.dvirUnit = unit;
      this.dvirTemplate = template;
      this.$router.push({
        name: "DVIRInspection",
        params: { inspectionId: `${inspection.id}` },
      });
    },
    onDVIRFormClosed() {
      this.dvirUnit = null;
      this.dvirTemplate = null;
      this.backToList();
    },
    onDVIRSubmitted() {
      this.onDVIRFormClosed();
    },
    onEditorClosed() {
      this.starterBase = null;
      this.backToList("templates");
    },
    // Back to the table. Re-entering the route remounts the component, so the
    // list refetches itself — no stale row after an edit.
    backToList(tab) {
      this.$router.push({ name: "DVIR", query: { tab: tab || this.activeTab } });
    },
    openAddModal() {
      if (this.activeTab === "dvirs") {
        this.$bvModal.show("modal-add-dvir-record");
        return;
      }
      this.$bvModal.show("modal-add-dvir");
    },
    formatDate(date) {
      return date ? moment(date).format("lll") : "-";
    },
    safetyStatusClass(status) {
      return `${status}`.toLowerCase() === "safe"
        ? "dvir-status-safe"
        : `${status}`.toLowerCase() === "unsafe"
          ? "dvir-status-unsafe"
          : "dvir-status-resolved";
    },
    editTemplate(item) {
      this.openEditor(item);
    },
    showTemplateDeletePopup(id) {
      this.templateID = id;
      this.showDeletePopup = true;
    },
    async duplicateTemplate(template) {
      try {
        this.setLoader(true);
        await this.duplicateDVIRTemplate(template.id);
        await this.getDVIRData();
        await this.setNotification({
          msg: this.$t("dvir.templateDuplicated"),
          type: "success",
          color: "green",
        });
      } catch (error) {
        await this.setNotification({
          msg: typeof error === "string" ? error : error.error || this.$t("dvir.templateSaveFailed"),
          type: "error",
          color: "red",
        });
      } finally {
        this.setLoader(false);
      }
    },
    async deleteTemplate(confirmed) {
      this.showDeletePopup = false;
      if (!confirmed) return;
      try {
        this.setLoader(true);
        await this.deleteDVIRTemplate(this.templateID);
        await this.getDVIRData();
        await this.setNotification({
          msg: this.$t("dvir.templateDeleted"),
          type: "success",
          color: "green",
        });
      } catch (error) {
        await this.setNotification({ msg: error.error ? error.error : error, type: "error", color: "red" });
      } finally {
        this.templateID = null;
        this.setLoader(false);
      }
    },
    // The filters go up as query params — "Draft" is a report with no safety
    // status yet, which the API expects as an empty progress_status.
    filterQuery() {
      const params = {
        search: this.filterFields.search.trim(),
        equipment_type: this.filterFields.equipment_type,
        inspection_type: this.filterFields.inspection_type,
        has_defects: this.filterFields.has_defects,
        defect_status: this.filterFields.defect_status,
        status: this.filterFields.safety_status,
      };
      // The picker holds a [start, end] pair; the API takes them separately.
      const date = this.filterFields.date;
      if (date && date[0]) {
        params.date_from = moment(date[0]).format("YYYY-MM-DD");
        params.date_to = moment(date[1] || date[0]).format("YYYY-MM-DD");
      }
      return Object.keys(params)
        .filter((key) => params[key] !== null && params[key] !== "")
        .map((key) => `${key}=${encodeURIComponent(params[key])}`)
        .join("&");
    },
    // The compliance report takes the search, date range, unit type, tags and units.
    reportQuery() {
      const params = {};
      const search = this.filterFields.search.trim();
      if (search) params.search = search;
      const date = this.filterFields.date;
      if (date && date[0]) {
        params.date_from = moment(date[0]).format("YYYY-MM-DD");
        params.date_to = moment(date[1] || date[0]).format("YYYY-MM-DD");
      }
      if (this.filterFields.equipment_type) {
        params.equipment_type = this.filterFields.equipment_type;
      }
      // The v-select holds an array of ids; the API wants them comma separated.
      const tagIDs = this.filterFields.tag_ids || [];
      if (tagIDs.length) {
        params.tag_ids = tagIDs.join(",");
      }
      const unitIDs = this.filterFields.unit_ids || [];
      if (unitIDs.length) {
        params.units_ids = unitIDs.join(",");
      }
      return Object.keys(params)
        .map((key) => `${key}=${encodeURIComponent(params[key])}`)
        .join("&");
    },
    async getDVIRData() {
      try {
        this.isTableMounted = false;
        if (this.activeTab === "templates") {
          const search = this.filterFields.search.trim();
          const data = await this.getAllDVIRTemplates(
            search ? `search=${encodeURIComponent(search)}` : ""
          );
          this.items = (data?.data || []).map((item) => ({
            id: item.id,
            name: item.name,
            assigned_summary: item.assigned_summary,
            is_active: item.is_active
          }));
        } else if (this.activeTab === "report") {
          const data = await this.getDVIRCompliance(this.reportQuery());
          const units = Array.isArray(data) ? data : data?.units || [];
          // The day columns come from the response; fall back to the keys on the
          // first template, in the order the API sent them.
          this.reportDates =
            data?.dates || Object.keys(units[0]?.templates?.[0]?.days || {});
          this.reportItems = units.flatMap((unit) =>
            (unit.templates || []).map((template) => ({
              id: `${unit.id}-${template.id}`,
              unit_no: unit.unit_no || "-",
              type: unit.type || "-",
              driver: (unit.driver || {}).name || "-",
              driver_id: unit.driver?.id,
              template_name: template.name,
              completion_rate: template.completion_rate,
              ...template.days,
            }))
          );
        } else if (this.activeTab === "dvirs") {
          const data = await this.getAllDVIRData(this.filterQuery());
          const inspections = Array.isArray(data) ? data : data?.data || [];
          this.dvirItems = inspections.map((item) => ({
            id: item.id,
            unit_no: item.unit_no || "-",
            equipment_type: item.unit_type || "-",
            template_name: item.template_name || "-",
            inspection_type: item.inspection_type,
            defect_status: item.defect_status,
            created_by: item.created_by?.name || "-",
            inspected_at: item.inspected_at,
            defect_count: item.defect_count || 0,
            fixed_count: item.fixed_count || 0,
            safety_status: item.safety_status,
            progress_status: item.progress_status,
            opened: item.opened,
            created_by_id: item.created_by?.id,
          }));
        }
      } catch (error) {
        console.error("Error fetching DVIR data:", error);
      } finally {
        this.isTableMounted = true;
      }
    },
    async getStarters() {
      const data = await this.getDVIRTemplateStarters();
      const starters = Array.isArray(data) ? data : data?.data || [];
      this.templateBases = starters.map((starter) => ({
        ...starter,
        style: this.starterStyles[starter.key] || this.defaultStarterStyle,
      }));
    },
  },
  async mounted() {
    await this.getDVIRData();
    await this.getStarters();
    await this.getAllTags();
    this.tags.map((item) => {
      this.allTags.push({
        id: item.id,
        label: item.add_tag,
      });
    })
  },
};
</script>
<style>
.dvir-export-btn>button {
  padding-left: 0px;
  padding-top: 0px;
  padding-bottom: 0px;
}
</style>
<style scoped>
.data-table >>> tr.row-opened > td {
  background-color: #f2f2f2;
}
.text-green {
  color: #2cce89;
}

.text-red {
  color: #ff0000;
}

/* Same divider the tabs use, between the report's fixed header columns. */
.data-table>>>th.th-divider {
  position: relative;
}

.data-table>>>th.th-divider::after {
  content: "";
  position: absolute;
  right: 0;
  top: 25%;
  height: 50%;
  width: 1px;
  background-color: #e3e3e3;
}

/* Unit # / Driver / Template stay in place while the day columns scroll. Each
   offset is the sum of the widths before it. */
.data-table>>>.sticky-col {
  position: sticky;
  z-index: 2;
  background-color: #ffffff;
}

/* The header cells are already sticky vertically from sticky-header, at the same
   z-index as the day headers — which then paint over them on a sideways scroll.
   These need !important to outrank BootstrapVue's own thead rule. */
.data-table>>>th.sticky-col {
  position: sticky !important;
  top: 0;
  z-index: 6 !important;
  background-color: #ffffff;
}

.data-table>>>.sticky-col-1 {
  left: 0;
  width: 120px;
  min-width: 120px;
}

.data-table>>>.sticky-col-2 {
  left: 120px;
  width: 120px;
  min-width: 120px;
}

.data-table>>>.sticky-col-3 {
  left: 240px;
  width: 160px;
  min-width: 160px;
}

.data-table>>>.sticky-col-4 {
  left: 400px;
  width: 240px;
  min-width: 240px;
  /* An inset shadow rather than a border: with border-collapse the browser
     paints cell borders in the table layer, so they scroll away from a sticky
     cell. A shadow is painted with the cell, so it stays at the boundary. */
  box-shadow: inset -1px 0 0 #e3e3e3;
}

.data-table>>>.sticky-col-end {
  right: 0;
  width: 70px;
  min-width: 70px;
  text-align: left;
  /* Shadows, not borders, for the same reason as the last fixed column — one
     line where the days end and one on the table's right edge. */
  box-shadow: inset 1px 0 0 #e3e3e3, inset -1px 0 0 #e3e3e3;
}

/* Day columns hold nothing but a box, so keep them narrow. b-table renders the
   cells itself, hence the deep selector. */
.data-table>>>th.day-col,
.data-table>>>td.day-col {
  width: 48px;
  min-width: 48px;
  padding-left: 8px;
  padding-right: 8px;
  text-align: center;
}

.data-table>>>th.day-col--today {
  background-color: #f4f4f4 !important;
}

/* Compliance report cell: filled when that day's DVIR was completed. */
.day-box {
  display: inline-block;
  width: 20px;
  height: 20px;
  border-radius: 4px;
  background-color: #f4f4f4;
}

.day-box--done {
  background-color: #2d69f6;
}

.dvir-status {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 100px;
  height: 30px;
  border-radius: 4px;
  color: #ffffff;
  font-size: 14px;
  text-transform: uppercase;
}

.dvir-status-safe {
  background-color: #2cce89;
}

.dvir-status-unsafe {
  background-color: #ff0000;
}

.dvir-status-resolved {
  background-color: #ffc800;
}

.dvir-status-draft {
  background-color: #f4f4f4 !important;
  border: 1px solid #eaeaea !important;
  color: black !important;
}

.starter-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}

@media (max-width: 575px) {
  .starter-grid {
    grid-template-columns: 1fr;
  }
}

.starter-card {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  padding: 1rem;
  text-align: left;
  background: #ffffff;
  border: 1px solid #e3e3e3;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.15s;
}

.starter-card:hover {
  border-color: rgba(45, 105, 246, 0.5);
  background-color: rgba(45, 105, 246, 0.05);
}

.starter-icon-img {
  width: 36px;
  height: 36px;
}

.starter-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  font-size: 18px;
}

.starter-sub {
  line-height: 1.4;
}
</style>
